import Audio from './src/Audio.vue'

Audio.install = function(Vue) {
    Vue.component(Audio.name, Audio)
}

export default Audio